import axios from 'axios';
import { IUser } from '../Types/user';

export const validateMicrosoftToken = (
  id_token: string,
  email: string,
  callback: (user: IUser) => void,
  errorCallback: (error: any) => void
) => {
  const URL = `${import.meta.env.VITE_API_BASE_URL}/auth/microsoft/validate/`;
  
  return axios.post(URL, { id_token, email })
    .then((response) => {
      if (callback) {
        callback(response.data as IUser);
      }
    })
    .catch((error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    });
};